import app from '@frontend/application-container';
import { img } from '@phi/components';
import { SettingsEntry } from '../settings-entry';
import { ConsistencyChecksIcon } from '..';
import FormToggle from '@frontend/components/FormToggle';
import { h } from 'vue';

export function InterruptDragOnIssue() {
    return SettingsEntry(
        'Interrupt drag when issues are found',

        '',

        img(ConsistencyChecksIcon, 'Interrupt drag when issues are found'),

        h(FormToggle, {
            value: app.state.interrupt_drag_at_failed_consistency_checks,
            'onUpdate:value': x => app.state.interrupt_drag_at_failed_consistency_checks = x,
        }),
    );
}
